import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { PrivateLayout } from "@/shared/components/layout";
import { PATH_ROUTER } from "@/shared/models/const/path";
import { C_PATH_ROUTER } from "@/src-refactor/modules/shared/model/const/path.const";
import PropertyRouterModule from "@src-rf/modules/private/properties/PropertiesRouter";
import MxErrorBoundary from "@/sentry/components/ErrorBoundary";
import AppMobilePage from "@/src-refactor/modules/private/app-mobile/pages/AppMobilePage";
import AppMobilePromoPage from "@/src-refactor/modules/private/app-mobile/pages/AppMobilePromoPage";

const UserModules = React.lazy(() => import("./modules/user/index.router"));
const ProfileModules = React.lazy(() => import("./modules/profile/index.router"));
const ToolsModule = React.lazy(
  () => import("../src-refactor/modules/private/tools/index.router")
);
const OwnersModules = React.lazy(() => import("@rf/owner/module/owners.router"));
const MortgageReferenceModule = React.lazy(
  () => import("../src-refactor/modules/private/mortgage/index.router")
);
const ReportModules = React.lazy(() => import("./modules/reports/index.router"));

const AgenciesModules = React.lazy(
  () => import("@src-rf/modules/private/agencies/pages/Agencies.router")
);

function PrivateRoute() {
  useEffect(() => {}, []);

  return (
    <PrivateLayout>
      <MxErrorBoundary>
        <Routes>
          <Route
            path={`${PATH_ROUTER.PRIVATE.ROOT.USERS}/*`}
            element={<UserModules />}
          />

          <Route
            path={`${PATH_ROUTER.PRIVATE.ROOT.PROFILE}/*`}
            element={<ProfileModules />}
          />

          <Route
            path={`${PATH_ROUTER.PRIVATE.ROOT.TOOLS}/*`}
            element={<ToolsModule />}
          />

          <Route
            path={`${PATH_ROUTER.PRIVATE.ROOT.OWNERS}/*`}
            element={<OwnersModules />}
          />
          <Route
            path={`${PATH_ROUTER.PRIVATE.ROOT.MORTGAGE_REFERENCE}/*`}
            element={<MortgageReferenceModule />}
          />
          <Route path={"reports/*"} element={<ReportModules />} />

          <Route
            path={`${C_PATH_ROUTER.APP_MOBILE.ROOT}`}
            element={<AppMobilePromoPage />}
          />

          <Route
            path={`${C_PATH_ROUTER.REALESTATE.ROOT}/*`}
            element={<PropertyRouterModule />}
          />

          <Route
            path={`${C_PATH_ROUTER.AGENCIES.ROOT}/*`}
            element={<AgenciesModules />}
          />

          <Route
            path="*"
            element={<Navigate to={`${C_PATH_ROUTER.REALESTATE.ROOT}`} />}
          />
        </Routes>
      </MxErrorBoundary>
    </PrivateLayout>
  );
}

export default PrivateRoute;
